import { Injectable } from '@angular/core';
import { Resolutions } from "@resolutions";
import { WindowRefService } from "@service/window-service/window-ref.service";
import { BlockMargin } from '@service/article/article.service';


@Injectable({
    providedIn: 'root'
})
export class MarginService
{
    constructor(
        private windowRef: WindowRefService,
    )
    {
    }

    public getCurrentMargin(blockMargin: BlockMargin): number
    {
        if (this.windowRef.getNativeWindowInnerWidth() <= Resolutions.resolutionTablet)
        {
            return blockMargin?.mobile || 0;
        } else if (this.windowRef.getNativeWindowInnerWidth() <= Resolutions.resolutionDesktop)
        {
            return blockMargin?.tablet || 0;
        } else
        {
            return blockMargin?.desktop || 0;
        }
    }
}